<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="preconnect" href="https://fonts.gstatic.com">
<link href="https://fonts.googleapis.com/css2?family=Caveat:wght@600&display=swap" rel="preload">
<div class="about">
    <div class="about__row">
        <div class="about__container">
            <h1 class="about__title" id="title">About</h1>
            <p class="about__text">
                At Vervendo, we are committed to offering travel services
                of the highest quality, blending our energy and enthusiasm,
                with our combined 40 years of experience in the travel industry.
            </p>
            <p class="about__text">
                Vervendo was first established in the year of 2016 and is located in Chania, Crete. Our satisfaction comes in serving our clients who want to experience the joy and inspiration of travelling to Crete.
            </p>
            <h3 class="about__quote">We talk, meet and inspect all the villas we offer in our platform.</h3>
            <p class="about__text">
                We only work with villas of high excellence and beauty to make sure your stay will be memorable. 
                Of course, we don't stop there! 
                As locals, we live, breathe and experience Crete daily, and we would love to share its beauty and wonders with all of you.
            </p>
            <!-- <ul id="list">
                                Therefore, we have partnered with many travel professionals to offer you the opportunity to 
                experience unique
                activities such as:
                    <li>Aroma Therapy Massage</li>
                    <li>Elafonisi Tour</li>
                    <li>Exploration of a cave</li>
                    <li>Helicopter Tour</li>
                    <li>Jeep Safari</li>
                    <li>Long Term Manicure</li>
                    <li>Private Cruise</li>
                    <li>Sup in Crete</li>
                    <li>A trip to Holy Monasteries</li>
                </ul>
                <b id="bold-text">And much more...!</b>
                 -->
            
            <!-- <p class="about__text">
                Just search for the villa of your choice and see how it can be bundled with 
                those activities and get the most from every moment in Crete!
            </p> -->
            <a class="about__link" href="/home">Take a peek of how it works<span class="about__arrow">-></span></a>
        </div>
    </div>
    <div class="about__row">
        <div class="about__container about__meaning">
            <div id="box">
                <div id="first">
                    <h3 id="meaning-text">What does Vervendo mean?</h3> 
                </div>
                <div id="second">
                    <p id="image-text">
                        The word is a "synthesis of <b>verum</b> 
                        and <b>vendere</b>(verum,verdunt),meaning <b>"good agreement"</b> 
                        in free translation...
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <p id="end-text">For PR/marketing purposes or property owners, please contact <a
                    href="#">info@vervendo.com</a></p>
        </div>
    </div> -->
</div>